// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style__welcome___IjVHd {
   font-size: 32px;
    margin-top: 20vh;
}

.style__sticknet___krOiD {
    font-family: 'Sirin Stencil', sans-serif;
}

.style__premium___h5aeS {
    font-weight: bold;
}
`, "",{"version":3,"sources":["webpack://./src/client/WelcomeScreen/style.css"],"names":[],"mappings":"AAAA;GACG,eAAe;IACd,gBAAgB;AACpB;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,iBAAiB;AACrB","sourcesContent":[".welcome {\n   font-size: 32px;\n    margin-top: 20vh;\n}\n\n.sticknet {\n    font-family: 'Sirin Stencil', sans-serif;\n}\n\n.premium {\n    font-weight: bold;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"welcome": `style__welcome___IjVHd`,
	"sticknet": `style__sticknet___krOiD`,
	"premium": `style__premium___h5aeS`
};
export default ___CSS_LOADER_EXPORT___;
